import React from 'react';
import {
   PtrnAccion,
   PtrnCampoGeneralBoton,
   PtrnColors,
   PtrnSize,
   PtrnTipoAccion
} from '../../patronTypes';
import PtrnAccionButton from '../PtrnAccionButton';
import {CampoGeneralProps} from './campoOtrosTypes';
import {PtrnPropsUtil} from '../../patronUtils';

export interface CG_ButtonProps {
   campoConfig: PtrnCampoGeneralBoton;
}

function CG_Button({
   campoConfig,
   ptrnRef,
   camposData,
   ruta,
   index
}: CG_ButtonProps & CampoGeneralProps) {
   //#endregion
   //#region retorno
   const paramAux = {ptrnRef, camposData, campoConfig};
   const botonAccion: PtrnAccion = {
      fn: campoConfig.onClick,
      icon: campoConfig.icon,
      label: campoConfig.generarValorMostrar
         ? campoConfig.generarValorMostrar(paramAux)
         : campoConfig.label,
      tipo: PtrnPropsUtil.getPropValue(PtrnTipoAccion.neutra, campoConfig.tipoAccion, paramAux)
   };
   const color = PtrnPropsUtil.getPropValue<PtrnColors>(
      PtrnColors.primary,
      campoConfig.color,
      paramAux
   );
   const title = PtrnPropsUtil.getPropValue<string|undefined>(
      undefined,
      campoConfig.title,
      paramAux
   );
   return (
      <PtrnAccionButton
         accion={botonAccion}
         name={campoConfig.name}
         color={color}
         title={title}
         posicionIcono={campoConfig.posicionIcono}
         ptrnRef={ptrnRef}
         camposData={camposData}
         size={campoConfig.size || PtrnSize.small}
         ruta={ruta}
         index={index}
         fullWidth
      />
   );
   //#endregion
}
export default CG_Button;
